
if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();

      this.updateOptions();
      this.updateMasterId(true);

      this.addEventListener('change', this.onVariantChange.bind(this));

      if (this.nodeName === 'VARIANT-SELECTS' && this.querySelectorAll('select').length > 1) {
        this.addEventListener('mousedown', this.onOptionSelect.bind(this));
        this.addEventListener('change', this.onOptionChange.bind(this));
        this.addEventListener('click', this.onOptionReset.bind(this));

        if (this.currentVariant) {
          this.querySelectorAll('.select__icon--reset').forEach((el) => el.classList.remove('hidden'));
        }
      }
    }

    onOptionSelect(event) {
      if (!event.target.matches('select')) return;

      // Continue only if the other options have values
      const otherOptions = this.querySelectorAll(`select:not([id$="-${event.target.id.substr(event.target.id.length - 1)}"])`);

      // Reset options if any of the options is empty
      if ([...otherOptions].find((o) => !o.value)) return [...event.target.options].forEach((e) => (e.disabled = false));

      // Find the available variants
      const availableOptions = this.getVariantData().reduce((a, e) => {
        let m = false;
        for (let i = 0; i < otherOptions.length; i++) {
          if (e[otherOptions[i].dataset.option] !== otherOptions[i].value) {
            m = false;
            break;
          }
          m = true;
        }

        if (m) a.push(e[event.target.dataset.option]);
        return a;
      }, []);

      // Toggle option availability
      [...event.target.options].forEach((e) => {
        if (e.value) e.disabled = !availableOptions.includes(e.value);
      });
    }

    // Expects the reset icon after select input
    onOptionChange(event) {
      if (event.target.value !== '') {
        event.target.nextElementSibling.classList.remove('hidden');
      } else {
        event.target.nextElementSibling.classList.add('hidden');
      }
    }

    onOptionReset(event) {
      if (!event.target.matches('.select__icon--reset')) return;
      event.target.previousElementSibling.value = '';
      event.target.previousElementSibling.dispatchEvent(new Event('change', { bubbles: true }));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', true);
      // this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateBisButton();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '');
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        // this.updateShareUrl();
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      console.log('updateOptions()', this.options);
    }

    updateMasterId(noevents) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });

      // Update window.Product object
      if (this.currentVariant && window.Product) {
        // window.Product.selected_variant = {
        //   id: this.currentVariant.id,
        //   available: this.currentVariant.available,
        // };
        window.Product.selected_variant = this.currentVariant;

        window.FindifyAPI && window.FindifyAPI.feedbackViewPage();
      }

      if (!noevents) {
        this.dispatchEvent(new CustomEvent('theme:variant:change', { detail: { variant: this.currentVariant }, bubbles: true }));
      }

      console.log('updateMasterId()', this.currentVariant);
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
      mediaGallery.showMediaForVariant(this.currentVariant);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

      // const modalContent = document.querySelector(
      //   `#ProductModal-${this.dataset.section} .product-media-modal__content`
      // );
      // const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      // modalContent.prepend(newMediaModal);
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const url = new URL(window.location);
      url.searchParams.set('variant', this.currentVariant.id);
      window.history.pushState({}, '', url);

      // window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    // updateShareUrl() {
    //   const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    //   if (!shareButton) return;
    //   shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    // }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    // updatePickupAvailability() {
    //   const pickUpAvailability = document.querySelector('pickup-availability');
    //   if (!pickUpAvailability) return;

    //   if (this.currentVariant && this.currentVariant.available) {
    //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
    //   } else {
    //     pickUpAvailability.removeAttribute('available');
    //     pickUpAvailability.innerHTML = '';
    //   }
    // }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          // Update info
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const productInfo = this.closest(".product__info");

          const subsBlock = document.querySelector(`#PlugSubscriptions-${this.dataset.section}`);
          const autoSelectFirstSub = (
            subsBlock
            && (
              !subsBlock.querySelector(".product-form__input").dataset.selectedVariant
              || productInfo.dataset.activeSellingPlanId
            )
          );

          if (subsBlock && productInfo.dataset.activeSellingPlanId) {
            const sellingPlanId = productInfo.dataset.activeSellingPlanId;
            const priceBlock = html.querySelector(`#Price-${this.dataset.section}`);
            Array.from(priceBlock.querySelectorAll(".price"))
              .forEach(price => {
                if (price.classList.contains("selling-plan-price") && price.dataset.sellingPlanId === sellingPlanId) {
                  price.classList.remove("is-hidden");
                } else {
                  price.classList.add("is-hidden");
                }
              });
          }

          this.renderEl(`Price-${this.dataset.section}`, html, 'theme:product:price:change');
          this.renderEl(`Availability-${this.dataset.section}`, html);
          this.renderEl(`SKU-${this.dataset.section}`, html);
          this.renderEl(`PlugSubscriptions-${this.dataset.section}`, html);

          if (subsBlock) {
            const parentBlock = subsBlock.closest(".product-block--subscriptions");
            const plugSubscriptions = productInfo.querySelector(`#PlugSubscriptions-${this.dataset.section}`);
            if (parentBlock) {
              parentBlock.classList.remove("is-hidden");
            }

            if (productInfo.dataset.activeSellingPlanId) {
              plugSubscriptions.selectValue(productInfo.dataset.activeSellingPlanId);
            } else if (autoSelectFirstSub) {
              plugSubscriptions.autoSelect();
            } else {
              plugSubscriptions.selectOneTime();
            }
          }

          // Update bundled products
          const bundledProducts = document.querySelector('bundled-products');
          if (bundledProducts) {
            if (!bundledProducts.isValid()) {
              this.toggleAddButton(true, window.variantStrings.makeASelection);
              return;
            }

            bundledProducts.updateBundleId();
          }

          // Update ATC
          if (this.currentVariant.available) {
            let priceStr = "";

            Array.from(productInfo.querySelectorAll(".product-block--price .price")).forEach(price => {
              if (!price.classList.contains("is-hidden")) {
                priceStr = price.querySelector(".price__selling").textContent;
              }
            });

            this.toggleAddButton(false, `${window.variantStrings.addToCart} — ${priceStr}`);
          } else {
            this.toggleAddButton(true);
          }

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.dataset.section,
              html,
              variant: this.currentVariant,
            },
          });
        });
    }

    renderEl(id, html, event = false) {
      const element = document.getElementById(id);
      const source = html.getElementById(id);
      const destination = document.getElementById(id);

      if (element && source && destination) {
        destination.innerHTML = source.innerHTML;
        element.removeAttribute('hidden');
        if (event) document.dispatchEvent(new CustomEvent(event, { bubbles: true }));
      }

      this.toggleAddButton();
    }

    /**
     * Toggles the add-to-cart button states.
     *
     * @param {Boolean} disable Toggle the `disabled` attribute.
     * @param {String} text The button label.
     * @param {Boolean} loading Toggle the spinner visibility.
     */
    toggleAddButton(disable = true, text = '', loading = false) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = addButton.querySelector('.product-form__submit__text');
      const makeASelectionText = addButton.querySelector('.product-form__submit__alt-text');
      const spinner = productForm.querySelector('.loading-overlay__spinner');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', '');
        makeASelectionText.removeAttribute('hidden');

        if (text === window.variantStrings.makeASelection) {
          addButton.classList.add('product-form__submit--no-selected-variant');
          addButtonText.innerHTML = window.variantStrings.addToCart;
        } else if (text === window.variantStrings.unavailable) {
          addButton.classList.add('product-form__submit--no-selected-variant');
          // addButtonText.innerHTML = text;
        } else if (text) {
          addButtonText.innerHTML = text;
        }
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.innerHTML = text ? text : window.variantStrings.addToCart;
        makeASelectionText.setAttribute('hidden', '');
      }

      if (loading) {
        addButton.classList.add('loading');
        spinner.removeAttribute('hidden');
      } else {
        addButton.classList.remove('loading');
        spinner.setAttribute('hidden', '');
      }

      const qtyInput = productForm.querySelector('.product-form__quantity');
      if (qtyInput) {
        if (disable && !loading && this.currentVariant) {
          qtyInput.setAttribute('hidden', '');
        } else {
          qtyInput.removeAttribute('hidden');
        }
      }

      document.dispatchEvent(new CustomEvent('theme:product:button:toggle', { bubbles: true }));
    }

    setButtonPrice(priceString) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = productForm.querySelector('[name="add"]');
      const priceSpan = addButton.querySelector(".product-form-atc__price");
      if (!priceSpan) {
        return;
      }

      priceSpan.textContent = ` — ${priceString}`;
    }

    setUnavailable() {
      if (this.options.filter((o) => o === undefined).length) return;
      this.toggleAddButton(true, window.variantStrings.unavailable);
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateBisButton() {
      if (!this.currentVariant) return;

      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const bisButton = productForm.querySelector('.btn--bis');
      if (!bisButton) return;

      addButton.classList.remove('product-form__submit--no-selected-variant');
      bisButton.dataset.variantId = this.currentVariant.id;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  // ===============================================================================================
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
      this.addEventListener('click', this.toggleUnavailable.bind(this));

      ['mouseenter', 'mouseleave'].forEach((eventType) => {
        this.querySelectorAll('.swatch').forEach((swatch) => swatch.addEventListener(eventType, this.updateTooltip.bind(this)));
      });

      this.querySelectorAll('.product-form__input--swatch input').forEach((input) => input.addEventListener('change', this.updateTooltip.bind(this)));
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      });

      // Set option2 states
      if (this.options.length >= 2 && this.options[0] !== undefined) {
        const variantOptions = this.getVariantData().reduce((o, e) => {
          if (e.option1 === this.options[0]) o.push([e.option2, e.available]);
          return o;
        }, []);

        const fieldset = this.querySelector('.product-form__input:nth-child(2)');
        const tooltip = fieldset.querySelector('.product__selected-option');

        fieldset.querySelectorAll('input').forEach((input) => {
          const variantOption = variantOptions.find((c) => c[0] === input.value);

          if (variantOption) {
            // Variant option is available
            input.disabled = false;

            if (variantOption[1]) {
              input.nextElementSibling.classList.remove('unavailable');
            } else {
              input.nextElementSibling.classList.add('unavailable');
            }

            return;
          }

          input.checked = false;
          input.disabled = true;
          input.nextElementSibling.classList.add('unavailable');
          this.toggleAddButton(true, window.variantStrings.makeASelection);

          if (tooltip.textContent.indexOf(input.value) > -1) {
            tooltip.classList.remove('product__selected-option--selected');
            tooltip.textContent = this.currentTooltipText = window.variantStrings.makeASelection;
          }
        });
      }
    }

    updateTooltip(event) {
      const el = event.target;
      if (!el.matches('input, label')) return;

      const tipContainer = el.closest('.product-form__input').querySelector('.product__selected-option');
      const newTooltipText = el.nodeName === 'LABEL' ? document.getElementById(el.htmlFor).value : el.value;
      this.currentTooltipText = this.currentTooltipText ?? tipContainer.textContent;
      if (!newTooltipText || !tipContainer) return;

      switch (event.type) {
        case 'mouseenter':
          if (this.currentTooltipText.indexOf(newTooltipText) > -1) break;
          clearTimeout(this.tooltipDelay);
          tipContainer.classList.add('product__selected-option--selecting');
          tipContainer.textContent = window.variantStrings.selectOption.replace('[option]', newTooltipText);
          break;

        case 'mouseleave':
          tipContainer.classList.remove('product__selected-option--selecting');
          this.tooltipDelay = setTimeout(() => (tipContainer.textContent = this.currentTooltipText), 100);
          break;

        case 'change':
          tipContainer.classList.remove('product__selected-option--selecting');
          tipContainer.classList.add('product__selected-option--selected');
          tipContainer.textContent = this.currentTooltipText = window.variantStrings.selectedOption.replace('[option]', newTooltipText);
          break;
      }
    }

    setUnavailable() {}

    toggleUnavailable(event) {
      if (!event.target.matches('.show-unavailable-toggle')) return;

      this.classList.toggle('show-unavailable');

      if (this.classList.contains('show-unavailable')) {
        event.target.textContent = window.variantStrings.hideUnavailable;
      } else {
        event.target.textContent = window.variantStrings.showUnavailable;
      }
    }
  }

  customElements.define('variant-radios', VariantRadios);
}